<div class="content-wrapper">
  <div class="col-12 grid-margin stretch-card">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Create Job Rotation Form</h4>
        <form #ngNewAdhocForm="ngForm" (ngSubmit)="ngNewAdhocForm.form.valid && onSubmit()" novalidate>

            <div class="row">
                <!-- Requester Name -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                      <label for="requesterName">Requester Name<span> *</span></label>
                      <input type="text" class="form-control" id="requesterName"  [(ngModel)]="requesterFullName" required
                        placeholder="e.g Mike Adenuga " name="requesterName" #requestername="ngModel" 
                        >
                        <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewAdhocForm.submitted && requestername.errors">
                       Requester name is required!
                      </div>
      
                    </div>
                  </div>

                  <!-- Requester Designation -->
                  <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                      <label for="requesterdesignation">Requester Designation<span> *</span></label>
                      <input type="text" class="form-control" id="requesterdesignation" placeholder="ex: Requester Designation" [(ngModel)]="requesterDesignation"
                      #RequesterDesignation="ngModel" name="requesterdesignation" required>
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewAdhocForm.submitted && RequesterDesignation.errors">
                      Designation is required!
                    </div>
                    </div>
                  </div>
            </div>

            <div class="row">
            <!-- Employee Email     -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="employeeEmail">Employee Email<span> *</span></label>
                        <ng-select [(ngModel)]="employeeEmail" name="employeeEmail" placeholder="Select Employee Email..." required #employeeEmailRef="ngModel" (change)="onEmployeeSelected($event)">
                        <ng-option *ngFor="let emp of Employees" [value]="emp.email">
                            {{emp.firstName}} - {{ emp.email }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && employeeEmailRef.invalid">
                        Employee name is required!
                        </div>
                    </div>
                </div>

                <!-- Employee Name -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="employeeName">Employee Name<span> *</span></label>
                        <input type="text" class="form-control" id="employeeName" placeholder="Employee Name" [(ngModel)]="employeeFullName"
                        #employeeNameRef="ngModel" name="employeeName" required>
                        <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewAdhocForm.submitted && employeeNameRef.errors">
                        Employee name is required!
                    </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- Employee Function -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="employeeFunction">Employee Function<span> *</span></label>
                        <input type="text" class="form-control" id="employeeFunction" placeholder="Employee Current Function" [(ngModel)]="employeeFunction"
                        #employeeFunctionRef="ngModel" name="employeeFunction" required>
                        <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewAdhocForm.submitted && employeeFunctionRef.errors">
                        Employee function is required!
                    </div>
                    </div>
                </div>

                <!-- Employee Unit -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="employeeUnit">Employee Unit<span> *</span></label>
                        <input type="text" class="form-control" id="employeeUnit" placeholder="Employee Unit" [(ngModel)]="employeeUnit"
                        #employeeUnitRef="ngModel" name="employeeUnit" required>
                        <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewAdhocForm.submitted && employeeUnitRef.errors">
                        Employee unit is required!
                    </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- Employee Location -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="employeeLocation">Employee Location<span> *</span></label>
                        <input type="text" class="form-control" id="employeeLocation" placeholder="Employee Location " [(ngModel)]="employeeLocation"
                        #employeeLocationRef="ngModel" name="employeeLocation" required>
                        <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewAdhocForm.submitted && employeeLocationRef.errors">
                        Employee location is required!
                    </div>
                    </div>
                </div>

                <!-- Employee Current Designation -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                      <label for="employeeCurrentDesignation">Current Designation<span> *</span></label>
                      <input type="text" class="form-control" id="employeeCurrentDesignation" placeholder="Current Designation" [(ngModel)]="employeeCurrentDesignation"
                      #EmployeeCurrentDesignation="ngModel" name="employeeCurrentDesignation" required>
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewAdhocForm.submitted && EmployeeCurrentDesignation.errors">
                      Current designation is required!
                    </div>
                    </div>
                  </div>
            </div>

            <div class="row">
                <!-- Employee Current Manager -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="currentManager">Current Manager<span> *</span></label>
                        <ng-select [(ngModel)]="currentManager" name="currentManager" placeholder="Select current manager..." required #currentManagerRef="ngModel">
                        <ng-option *ngFor="let manager of Managers" [value]="manager.email">
                            {{ manager.firstName }} - {{ manager.email }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && currentManagerRef.invalid">
                        Current manager is required!
                        </div>
                    </div>
                </div>

                <!-- Employee Unit Head -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="currentUnitHead">Current Unit Head<span> *</span></label>
                        <ng-select [(ngModel)]="currentUnitHead" name="currentUnitHead" placeholder="Select unit head..." required #currentUnitHeadRef="ngModel">
                        <ng-option *ngFor="let hod of Managers" [value]="hod.email">
                            {{ hod.firstName }} - {{ hod.email }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && currentUnitHeadRef.invalid">
                        Current unit head is required!
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">         
                <!-- Current Section -->
                  <div class="col-12 col-md-6 mb-3" *ngIf ='isIndustrialFunction'>  
                    <div class="form-group">
                      <label for="currentSection">Current Section</label>
                      <input type="text" class="form-control" id="currentSection" placeholder="Input current section..." [(ngModel)]="currentSection"
                      #currentSectionRef="ngModel" name="currentSection" >
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewAdhocForm.submitted && currentSectionRef.errors">
                      Current section is required!
                    </div>
                    </div>
                  </div>

                  <div class="col"></div>

            </div>


            <hr>


            <div class="row">
                <!-- Rotation Category Section -->
                <!-- <div class="col-12 col-md-4 mb-3">
                    <div class="form-group">
                        <label for="rotationCategory">Rotation Category<span> *</span></label>
                        <input type="text" class="form-control" id="rotationCategory" placeholder="Input rotation category" [(ngModel)]="rotationCategory"
                        #rotationCategoryRef="ngModel" name="rotationCategory" required>
                        <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewAdhocForm.submitted && rotationCategoryRef.errors">
                        Rotation category is required!
                        </div>
                    </div>
                </div> -->
                <!-- <div class="col-12 col-md-4 mb-3">
                    <div class="form-group">
                        <label for="rotationCategory">Rotation Category<span> *</span></label>
                        <ng-select [(ngModel)]="rotationCategory" name="rotationCategory" placeholder="Select rotation category..."  #rotationCategoryRef="ngModel">
                        <ng-option *ngFor="let cat of rotationCat" [value]="cat.name">
                            {{ cat.name }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && rotationCategoryRef.invalid">
                        Rotation category is required!
                        </div>
                    </div>
                </div> -->




                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="rotationStartDate">Rotation Start Date<span> *</span></label>
                        <input type="date" class="form-control" [(ngModel)]="rotationStartDate" name="rotationStartDate" required #rotationStartDateRef="ngModel">
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && rotationStartDateRef.invalid">
                        Start date is required!
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="rotationEndDate">Rotation End Date<span> *</span></label>
                        <input type="date" class="form-control" [(ngModel)]="rotationEndDate" name="rotationEndDate" required #rotationEndDateRef="ngModel">
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && rotationEndDateRef.invalid">
                        End date is required!
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <!-- New Designation -->
                   <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="newDesignation">New Designation<span> *</span></label>
                        <input type="text" class="form-control" id="newDesignation" placeholder="Enter employee new designation" [(ngModel)]="newDesignation"
                        #newDesignationRef="ngModel" name="newDesignation" required>
                        <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewAdhocForm.submitted && newDesignationRef.errors">
                        New designation is required!
                        </div>
                    </div>
                </div>

                <!-- Receiving Function -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="receivingFunction">Receiving Function<span> *</span></label>
                        <ng-select [(ngModel)]="receivingFunction" name="receivingFunction" placeholder="Select receiving function..."  #receivingFunctionRef="ngModel" 
                        (change) = "onReceivingFunctionChange($event)">
                        <ng-option *ngFor="let dept of Departments" [value]="dept.name">
                            {{ dept.name }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && receivingFunctionRef.invalid">
                        Receiving function is required!
                        </div>
                    </div>
                </div> 

            </div>


            <div class="row">

               <!-- Receiving Location -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="receivingLocation">Receiving Location<span> *</span></label>
                        <ng-select [(ngModel)]="receivingLocation" name="receivingLocation" placeholder="Select receiving location..."  #receivingLocationRef="ngModel"
                        (change) = "onReceivingLocationChange($event)">
                        <ng-option *ngFor="let loc of Locations" [value]="loc.name">
                            {{ loc.name }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && receivingLocationRef.invalid">
                        Receiving location is required!
                        </div>
                    </div>
                </div> 

                <!-- Receiving Unit -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label for="receivingUnit">Receiving Unit<span> *</span></label>
                        <ng-select [(ngModel)]="receivingUnit" name="receivingUnit" placeholder="Select receiving unit..."  #receivingUnitRef="ngModel" 
                        (change) = "onReceivingUnitChange($event)">
                        <ng-option *ngFor="let function of Functions" [value]="function.name">
                            {{ function.name }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && receivingUnitRef.invalid">
                        Receiving unit is required!
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
              <!-- Receiving Manager -->
                <div class="col-12 col-md-6 mb-3" *ngIf = "!(isSameFunction && isSameLocation && isSameUnit)">
                    <div class="form-group">
                        <label for="receivingManager">Receiving Manager<span> *</span></label>
                        <ng-select [(ngModel)]="receivingManager" name="receivingManager" placeholder="Select receiving manager..."  #receivingMngrRef="ngModel">
                        <ng-option *ngFor="let manager of Managers" [value]="manager.email">
                            {{ manager.firstName }} - {{ manager.email }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && receivingMngrRef.invalid">
                        Receiving manager is required!
                        </div>
                    </div>
                </div>

                <!-- Receiving Unit Head -->
                <div class="col-12 col-md-6 mb-3" *ngIf = "!(isSameFunction && isSameLocation && isSameUnit)">
                    <div class="form-group">
                        <label for="receivingUnitHead">Receiving Unit Head<span> *</span></label>
                        <ng-select [(ngModel)]="receivingUnitHead" name="receivingUnitHead" placeholder="Select receiving unit head..."  #receivingUnitHeadRef="ngModel">
                        <ng-option *ngFor="let hod of Managers" [value]="hod.email">
                            {{ hod.firstName }} - {{ hod.email }}
                        </ng-option>
                        </ng-select>
                        <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && receivingUnitHeadRef.invalid">
                        Receiving unit head is required!
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">

              <!-- New Section -->
                <div class="col-12 col-md-6 mb-3"  *ngIf ='isIndustrialFunction'>
                    <div class="form-group">
                        <label for="newSection">New Section</label>
                        <input type="text" class="form-control" id="newSection" placeholder="Input new section..." [(ngModel)]="newSection"
                        #newSectionRef="ngModel" name="newSection">
                        <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewAdhocForm.submitted && newSectionRef.errors">
                        New section is required!
                        </div>
                    </div>
                </div>

                <div class="col"  *ngIf ='!isIndustrialFunction'></div>

            </div>

          <hr>

          <div class="col-12">
            <h4 class="card-title">Approvals</h4>
            <table class="table table-bordered">
              <tbody>
                <tr class="table-success" *ngIf ='showHeadHR'>
                  <!-- <td>4</td> -->
                  <td>Head of HR/Industrial Relations</td>
                  <td>
                    <ng-select [(ngModel)]="headOfHROrIndustrialRelationsToApprove" name="headOfHROrIndustrialRelationsToApprove" #hrRef="ngModel">
                      <ng-option *ngFor="let hr of HRBPS" [value]="hr.email">
                        {{ hr.firstName }} - {{ hr.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && hrRef.invalid">
                      Please provide Head of Industial Relation to approve.
                    </div>
                  </td>
                </tr>
                <tr class="table-success" *ngIf = 'showCurrentFuncDir'>
                  <!-- <td>2</td> -->
                  <td>Current Function Director</td>
                  <td>
                    <ng-select [(ngModel)]="currentFunctionalDirectorToApprove" name="currentFunctionalDirectorToApprove"  #currentFunctionalDirectorToApproveRef="ngModel">
                      <ng-option *ngFor="let director of FunctionalDirectors" [value]="director.email">
                        {{ director.firstName }} - {{ director.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && currentFunctionalDirectorToApproveRef.invalid">
                      Please provide Function Director to approve.
                    </div>
                  </td>
                </tr>
                <tr class="table-success" *ngIf ='showHRBP'>
                  <!-- <td>4</td> -->
                  <td> HRBP</td>
                  <td>
                    <ng-select [(ngModel)]="hrbpForNonIndustrialToApprove" name="hrbpForNonIndustrialToApprove" #hrbpRef="ngModel">
                      <ng-option *ngFor="let hr of HRBPS" [value]="hr.email">
                        {{ hr.firstName }} - {{ hr.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && hrbpRef.invalid">
                      Please provide HRBP to approve.
                    </div>
                  </td>
                </tr>

                <tr class="table-success" *ngIf = 'showPlantMngr'>
                  <!-- <td>1</td> -->
                  <td> Plant Manager</td>
                  <td>
                    <ng-select [(ngModel)]="plantManagerApprovalToApprove" name="plantManagerApprovalToApprove" #plantManagerApprovalToApproveRef="ngModel">
                      <ng-option *ngFor="let plantManager of PlantManagers" [value]="plantManager.email">
                        {{ plantManager.firstName }} - {{ plantManager.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && plantManagerApprovalToApproveRef.invalid">
                      Please provide Plant Manager to approve.
                    </div>
                  </td>
                </tr>
                
                <tr class="table-success" *ngIf = 'showReceivingFuncDir'>
                  <!-- <td>2</td> -->
                  <td>Receiving Function Director</td>
                  <td>
                    <ng-select [(ngModel)]="receivingFunctionalDirectorToApprove" name="receivingFunctionalDirectorToApprove"  #receivingFunctionalDirectorToApproveRef="ngModel">
                      <ng-option *ngFor="let director of FunctionalDirectors" [value]="director.email">
                        {{ director.firstName }} - {{ director.email }}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && receivingFunctionalDirectorToApproveRef.invalid">
                      Please provide Function Director to approve.
                    </div>
                  </td>
                </tr>
                <tr class="table-success" *ngIf = 'showOHRD'>
                   <!-- <td>{{hrCount}}</td> -->
                    <td>O & HR Director</td>
                    <td>{{ohrdToApprove}}</td>
                </tr>
                
              </tbody>
            </table>
          </div>

          <hr>
          <button type="submit" class="btn btn-primary mr-2">Submit</button>
          <button type="button" class="btn btn-light" (click)="onCancel()">Cancel</button>
        </form>
      </div>
    </div>
  </div>
</div>
